import { useMemo } from 'react';

import { atom, useRecoilState, useRecoilValue } from 'recoil';

import { TimeseriesCollection } from './types';

export const timeseriesAtom = atom<TimeseriesCollection>({
  key: 'timeseriesAtom',
  default: [],
});

export const useTimeseriesAtom = () => useRecoilState(timeseriesAtom);

export const useTimeseriesItemValue = (tsExternalId: string | undefined) => {
  const timeseriesValues = useRecoilValue(timeseriesAtom);
  return useMemo(
    () =>
      timeseriesValues.find(
        (timeseries) => timeseries.externalId === tsExternalId
      ),
    [timeseriesValues, tsExternalId]
  );
};
